export enum ToolTier {
    Stone,
    Bronze,
    Silver,
    Gold,
}